import React, {Component, useEffect, useState} from "react";
import {Session, User} from "../types/Types";
import {Card} from "react-bootstrap";
import UserRow from "./UserRow";
import LeaderboardNav from "./LeaderboardNav";
import {addNumberSuffix} from "../util/Util";
import PageTracking from "../auth/PageTracking";
import {V2GlassPanel} from "../shared/v2/V2Glass";
import LeaderboardV2Rows from "./LeaderboardV2Rows";

interface Props {
    users: Array<User>;
    currentUser: User | undefined;
    sessionsMap: Map<string, Session>;
}

function LeaderboardVisits(props: Props) {

    const [rank, setRank] = useState<number>(0);

    const getVisitCount = (user: User): number => Number(user.stats?.visits ?? user.visitCount ?? 0);
    const usersById = new Map(props.users.map((user) => [user.id, user]));
    if (props.currentUser && !props.currentUser.socialDisabled) {
        // The users collection is loaded once, so use the live current-user document
        // when a visit count has been corrected since that initial load.
        usersById.set(props.currentUser.id, props.currentUser);
    }
    const filteredUsers = Array.from(usersById.values())
        .filter((user) => {return !user.socialDisabled})
        .filter((user) => {return getVisitCount(user) > 0});

    const v2RankedUsers = [...filteredUsers].sort((a, b) => getVisitCount(b) - getVisitCount(a));
    const v2Rank = props.currentUser
        ? v2RankedUsers.findIndex((user) => user.id === props.currentUser?.id) + 1
        : 0;
    const currentUserHasVisits = props.currentUser ? getVisitCount(props.currentUser) > 0 : false;

    useEffect(() => {
        (async () => {
            filteredUsers.map((user, index) => {
                if(props.currentUser && user.id === props.currentUser.id) {
                    setRank(index - 1);
                    return;
                }
            });
        })();
    }, [props.users, props.currentUser]);

    return (
        <>
            <PageTracking />
            {props.currentUser && <>
            <LeaderboardNav currentUser={props.currentUser} />
            {props.currentUser.enableUiV2 ? <V2GlassPanel className="leaderboard-v2-list-card v2-glass-list-panel">
                <div className="leaderboard-v2-summary">
                    {v2Rank > 0 && <span>You&apos;re ranked <b>{v2Rank}{addNumberSuffix(v2Rank)}</b> out of <b>{v2RankedUsers.length}</b></span>}
                    {v2Rank === 0 && <span>{currentUserHasVisits ? "You’re not ranked yet." : "You are yet to visit."}</span>}
                </div>
                <LeaderboardV2Rows
                    rows={v2RankedUsers.map((user) => ({
                        user,
                        value: getVisitCount(user),
                        session: props.sessionsMap.get(user.id),
                    }))}
                    linksToTab="visits"
                    emptyMessage="No visits recorded yet."
                />
            </V2GlassPanel> : props.users && <Card className={"mb-3"}>
                <Card.Header>
                    {(props.users.length == 0 || rank === 0) && <div>Calculating...</div>}
                    {(props.users.length > 0 && rank > 0) && <div>You're ranked: {rank}<small>{addNumberSuffix(rank)}</small> out of {filteredUsers.length}</div>}
                </Card.Header>
                <Card.Body style={{paddingTop: "0.4em"}}>
                    {filteredUsers.map((user: User, index: number) => (
                        <UserRow linksToTab="visits" countToDisplay={getVisitCount(user).toString()} key={user.id} index={index} user={user} session={props.sessionsMap.get(user.id)}/>
                    ))}
                    {(props.users.length == 0 || rank === 0) && <div className={'loading'}>
                        Loading...
                    </div>}
                </Card.Body>
            </Card>}
        </>}
        </>
    );
}

export default LeaderboardVisits;
